// extracted by mini-css-extract-plugin
export default {"tab":"tabs_tab__D6Mgl","hidden":"tabs_hidden__x09zF"};